module.exports = __webpack_public_path__ + "LatoLatin-Light.c425d3f33c7cfa180fd6.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Light.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Light.woff2
// module chunks = styles